import mutations from "@/store/mutations";
import mocksStore from "@/__mocks__/store-mock.js";
import { PCG7 } from "@/config/constants";
import Vue from "vue";

jest.mock("vue", () => ({
  set: jest.fn()
}));

describe("Mutations de Vuex store", () => {
  it("Los métodos deben estar definidos", () => {
    global._BBVA_MOTOR = "ofertaCajaAhorro";
    const payload = {
      respuesta: { cbu: "" },
      name: "consulta",
      oferta: {
        paquetes: [{ tipoPaquete: "00", tarjetas: [] }],
        cajasDeAhorro: []
      },
      sujetoObligado: "0",
      otp: "",
      deviceUdid: ""
    };

    const state = mocksStore.state;
    state.confirmarRenaper.yaValido = true;

    expect(mutations.ON_ROUTE(state, payload)).not.toBeNull();
    expect(mutations.ON_GRACIAS(state, payload)).not.toBeNull();
    expect(mutations.ON_GRACIAS_CA(state, payload)).not.toBeNull();
    expect(mutations.ON_GRACIAS_GTM(state, payload)).not.toBeNull();
    expect(mutations.ON_IS_LOADING(state, payload)).not.toBeNull();
    expect(mutations.ON_FORZAR_DNE(state, payload)).not.toBeNull();
    expect(mutations.ON_OFFER(state, payload)).not.toBeNull();
    expect(mutations.ON_OFFER(state, payload)).not.toBeNull();
    expect(mutations.ON_PASO_1(state, payload)).not.toBeNull();
    expect(mutations.ON_PASO_2(state, payload)).not.toBeNull();
    expect(mutations.ON_PASO_3(state, payload)).not.toBeNull();
    expect(mutations.ON_PASO_4(state, payload)).not.toBeNull();
    expect(
      mutations.onSelectEncotesaAlternativo(state, payload)
    ).not.toBeNull();
    expect(mutations.onSelectEncotesaParticular(state, payload)).not.toBeNull();
    expect(mutations.ON_MODIFICAR_DOMICILIO(state, payload)).not.toBeNull();
    expect(
      mutations.ON_NORMALIZAR_DOMICILIO_ALTE(state, payload)
    ).not.toBeNull();
    expect(
      mutations.ON_NORMALIZAR_DOMICILIO_PART(state, payload)
    ).not.toBeNull();
    expect(mutations.ON_OTRO_DOMICILIO(state, payload)).not.toBeNull();
    expect(mutations.ON_SUCURSAL(state, payload)).not.toBeNull();
    expect(mutations.ON_QUERY(state, payload)).not.toBeNull();
    expect(mutations.ON_SOLICITAR_TURNO(state, payload)).not.toBeNull();
    expect(mutations.ON_SOCIAL_NET_STATUS(state, payload)).not.toBeNull();
    expect(mutations.ON_SEARCH_ENCOTESA(state, payload)).not.toBeNull();
    expect(mutations.ON_CONFIRMAR_RENAPER(state, payload)).not.toBeNull();
    expect(mutations.ON_CONFIRMAR_RENAPER_FLAG(state, payload)).not.toBeNull();
    expect(mutations.ON_INGRESO_BANCA_ONLINE(state, payload)).not.toBeNull();
    expect(mutations.ON_INTERNAL_LINK(state, payload)).not.toBeNull();
    expect(mutations.ADOBE_APP_STARTED(state, payload)).not.toBeNull();
    expect(mutations.ADOBE_APP_ON_CLICK_START(state, payload)).not.toBeNull();
    expect(mutations.ON_MOCK(state, payload)).not.toBeNull();
    expect(mutations.ON_NOTIFICATION_TOAST(state, payload)).not.toBeNull();
    expect(mutations.ON_OPEN_MODAL(state, payload)).not.toBeNull();
    expect(mutations.onTCode(state, payload)).not.toBeNull();
    expect(mutations.ON_DEVICEID(state, payload)).not.toBeNull();
    expect(mutations.ON_DEVICEIDTIMESTAMP(state, payload)).not.toBeNull();
    expect(mutations.ON_USER_TOKENIZADO(state, payload)).not.toBeNull();
    expect(mutations.ON_ADOBE_TARGET_EXPERIENCE(state, payload)).not.toBeNull();
    expect(mutations.ON_DOMICILIO(state, {})).not.toBeNull();
    expect(mutations.ON_CONSULTA(state, payload)).not.toBeNull();
    expect(mutations.ON_OFERTA(state, payload)).not.toBeNull();
    expect(mutations.ON_DATOS_PERSONALES(state, {})).not.toBeNull();
    expect(mutations.ON_VALIDANDO_DOMICILIO(state, payload)).not.toBeNull();
    expect(mutations.ON_VALIDANDO_DOMICILIO(state, null)).not.toBeNull();
    expect(mutations.ON_SUCURSALES(state, payload)).not.toBeNull();
    expect(mutations.ON_DATOS_LABORALES(state, payload)).not.toBeNull();
    expect(mutations.ON_INFORMACION_ADICIONAL(state, payload)).not.toBeNull();
    expect(mutations.ON_THANKS_VERIDAS(state, payload)).not.toBeNull();
    expect(mutations.ON_DIGITAL_PRESENCIAL(state, payload)).not.toBeNull();
    expect(mutations.ON_RESULT_VERIDAS(state, payload)).not.toBeNull();
    expect(mutations.ON_PRELOAD_SDK(state, payload)).not.toBeNull();
    expect(mutations.ON_SAVE_IFRAME(state, payload)).not.toBeNull();
    expect(mutations.SET_DVS_IFRAME_DATA(state, payload)).not.toBeNull();
    expect(mutations.ON_ERROR_VERIDAS(state, "")).not.toBeNull();
    expect(mutations.ON_DATA_AUTH_ASO(state, payload)).not.toBeNull();
    expect(mutations.ON_CLICK_CTA(state, payload)).not.toBeNull();
    expect(mutations.ON_VERIDAS_EVENT(state, payload)).not.toBeNull();
    expect(mutations.ON_IS_VISIBLE_SDK(state, payload)).not.toBeNull();
    expect(mutations.ON_FUNNEL_ERROR(state, payload)).not.toBeNull();
    expect(mutations.ON_LOGIN(state, payload)).not.toBeNull();
    expect(mutations.ON_BIOMETRIA_POSITIVO(state, payload)).not.toBeNull();
    expect(mutations.ON_CONFIGURACION(state, payload)).not.toBeNull();
    expect(mutations.ON_CONTRATACION(state, payload)).not.toBeNull();
    expect(mutations.ON_CONSULTA_CONTRATO(state, payload)).not.toBeNull();
    expect(mutations.ON_CONTRATO(state, payload)).not.toBeNull();
    expect(mutations.ON_FIRMA_CONTRATOS(state, payload)).not.toBeNull();
    expect(mutations.ON_SEGMENTO_SCORE_CLIENTE(state, payload)).not.toBeNull();
    expect(mutations.ON_CUENTA(state, payload)).not.toBeNull();
    expect(mutations.ON_OTP_ERROR(state, payload)).not.toBeNull();
    expect(mutations.ON_OTP_ONE(state, payload)).not.toBeNull();
    expect(mutations.ON_USUARIO_CLAVE(state, payload)).not.toBeNull();
    expect(mutations.ON_NORMALIZAR_CELULAR(state, payload)).not.toBeNull();
    expect(mutations.ON_CELULAR(state, payload)).not.toBeNull();
  });

  it("ON_DOMICILIO PCG7 lote 000 y casa 000", () => {
    const state = mocksStore.state;
    const payload = {
      localid: "caba",
      validarPreexistente: "validado",
      codPais: "54",
      codPost: "11",
      desDomi: "Domicilio",
      tDomic: PCG7.TDOMIC.CORRESPONDENCIA,
      lote: "000",
      casa: "000",
      codProv: "01"
    };
    mutations.ON_DOMICILIO(state, payload);
    expect(state.domicilioAlternativo).toEqual({
      accion: "",
      alternativo: false,
      calle1: "",
      calle2: "",
      casa: "",
      claIden: "",
      codIden: "",
      codModi: "",
      codNuev: "",
      codPais: "54",
      codPost: "11",
      codProv: "01",
      coorX: "",
      coorY: "",
      desDomi: "Domicilio",
      dudas: [],
      indBloq: "",
      indDuda: "",
      indOrig: "WEB",
      indPref: "",
      inusual: false,
      localid: "caba",
      lote: "",
      manzana: "",
      numModi: "",
      opcion: "",
      parcela: "",
      preexistente: true,
      rehacer: false,
      sector: "",
      tDoModi: "",
      tDomic: "10",
      tipImb: "",
      titul: "",
      valModi: "",
      valNuev: "",
      errores: []
    });
  });

  afterEach(() => {
    jest.clearAllMocks();
  });

  it("ON_DATA_AUTH_ASO", () => {
    const state = {
      dataAuthASO: {}
    };

    const payload = {
      tsec: "testPayload",
      tsecExpiry: 123456789
    };

    Vue.set = jest.fn((state, key, value) => {
      state[key] = value;
    });

    mutations.ON_DATA_AUTH_ASO(state, payload);
    expect(state.dataAuthASO).toBe(payload);
  });
  it("SET_DVS_IFRAME_DATA", () => {
    const state = {
      DVSIframeData: {
        id: "",
        urlXpressId: ""
      }
    };

    const iframeData = {
      id: "iframeId",
      urlXpressId: "https://example.com"
    };

    Vue.set = jest.fn((state, key, value) => {
      state[key] = value;
    });

    mutations.SET_DVS_IFRAME_DATA(state, iframeData);
    expect(Vue.set).toHaveBeenCalledWith(state, "DVSIframeData", iframeData);
    expect(state.DVSIframeData.id).toBe(iframeData.id);
    expect(state.DVSIframeData.urlXpressId).toBe(iframeData.urlXpressId);
  });

  it("RESET_DVS_IFRAME_DATA", () => {
    const state = {
      DVSIframeData: {
        urlXpressId: "existing-url",
        id: "existing-id"
      }
    };

    Vue.set = jest.fn((state, key, value) => {
      state[key] = value;
    });

    mutations.RESET_DVS_IFRAME_DATA(state);

    expect(Vue.set).toHaveBeenCalledWith(state, "DVSIframeData", {
      urlXpressId: "",
      id: ""
    });
  });

  it("ON_ERROR", () => {
    const state = {
      error: null
    };
    const errorPayload = "test-error-message";

    mutations.ON_ERROR(state, errorPayload);

    expect(state.error).toBe(errorPayload);
  });
});
